'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const clsx = require('clsx');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');
const components_display_Img_Img = require('../../display/Img/Img.cjs.js');
const components_marketing_LogoBar_logoIcons = require('./logoIcons.cjs.js');

const root = "_root_y2734_1";
const title = "_title_y2734_9";
const logosContainer = "_logos-container_y2734_27";
const logoContainer = "_logo-container_y2734_43";
const desktopLogoContainer = "_desktop-logo-container_y2734_49";
const mobileLogoContainer = "_mobile-logo-container_y2734_59";
const defaultLogo = "_default-logo_y2734_69";
const styles = {
	root: root,
	title: title,
	logosContainer: logosContainer,
	logoContainer: logoContainer,
	desktopLogoContainer: desktopLogoContainer,
	mobileLogoContainer: mobileLogoContainer,
	defaultLogo: defaultLogo
};

const DefaultLogo = (props) => {
  return jsxRuntime.jsx("span", { className: clsx.clsx(styles.defaultLogo, "logobar-defaultLogo"), style: {
    "--_zds-logobar-logosize": props.size ? `${props.size}px` : ""
  }, dangerouslySetInnerHTML: { __html: props.svg } });
};
const DefaultLogoIcons = {
  Asana: {
    mobile: components_marketing_LogoBar_logoIcons.AsanaIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.AsanaIcon
  },
  Dropbox: {
    mobile: components_marketing_LogoBar_logoIcons.DropboxIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.DropboxIcon
  },
  Meta: {
    mobile: components_marketing_LogoBar_logoIcons.MetaIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.MetaIcon
  },
  Shopify: {
    mobile: components_marketing_LogoBar_logoIcons.ShopifyIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.ShopifyIcon
  },
  Slack: {
    mobile: components_marketing_LogoBar_logoIcons.SlackIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.SlackIcon
  }
};
const LogoBar = (_props) => {
  const { title, items, size, className } = _props;
  return jsxRuntime.jsxs("div", { className: clsx.clsx(styles.root, className), "data-zds": true, children: [jsxRuntime.jsx(components_display_Heading_HeadingLevel.HeadingLevel, { children: jsxRuntime.jsx(components_display_Heading_Heading.Heading, { children: jsxRuntime.jsx("div", { className: clsx.clsx(styles.title, "logobar-title"), "data-zds": true, children: title }) }) }), jsxRuntime.jsx("ul", { className: clsx.clsx(styles.logosContainer, "logobar-logosContainer"), "data-zds": true, children: items && items.length > 0 ? items.map(({ logoUrl, companyName }, i) => jsxRuntime.jsx("li", { className: styles.logoContainer, "data-zds": true, children: jsxRuntime.jsx(components_display_Img_Img.Img, { alt: companyName, borderRadius: "none", src: logoUrl, height: size, width: size }) }, i + logoUrl)) : components_marketing_LogoBar_logoIcons.DefaultCompanies.map((company) => jsxRuntime.jsxs(React.Fragment, { children: [jsxRuntime.jsx("li", { className: clsx.clsx(styles.logoContainer, styles.desktopLogoContainer), "data-zds": true, children: jsxRuntime.jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].desktop, { size })) }), jsxRuntime.jsx("li", { className: clsx.clsx(styles.logoContainer, styles.mobileLogoContainer), "data-zds": true, children: jsxRuntime.jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].mobile, { size })) })] }, company)) })] });
};

exports.LogoBar = LogoBar;
//# sourceMappingURL=LogoBar.cjs.js.map
